module.exports = __webpack_public_path__ + "static/img/VG.8c91bb9f.svg";